/**
 * Collection Endorsed Section — standalone JS
 * Extracted from homepage-section-endorsed.liquid inline script
 * Infinite-scroll logo marquee via requestAnimationFrame
 * Zero external dependencies
 */
document.addEventListener('DOMContentLoaded', function () {

    var sections = document.querySelectorAll('.collect-endorsed-section');

    if (!sections.length) {
        return;
    }

    /**
     * Initialise a single endorsed marquee instance
     */
    function initEndorsed(section) {
        if (section.dataset.endorsedInit === 'true') {
            return;
        }

        section.dataset.endorsedInit = 'true';

        var track = section.querySelector('.collect-endorsed-track');

        if (!track) {
            return;
        }

        /* --- Capture source HTML from the first row ----- */
        var sourceRow = track.querySelector('.collect-endorsed-track-row');
        var sourceMarkup = sourceRow ? sourceRow.innerHTML.trim() : '';

        if (!sourceMarkup) {
            return;
        }

        var animationFrameId = null;
        var lastTimestamp = null;
        var offset = 0;
        var baseWidth = 0;

        /* --- Speed: 42px/s desktop, 30px/s mobile ------- */
        var getSpeed = function () {
            return window.matchMedia('(max-width: 767px)').matches ? 30 : 42;
        };

        /* --- Build cloned tracks to cover viewport ------- */
        var buildTracks = function () {
            track.innerHTML = '';

            var primaryRow = document.createElement('div');
            primaryRow.className = 'collect-endorsed-track-row';
            primaryRow.innerHTML = sourceMarkup;
            track.appendChild(primaryRow);

            baseWidth = primaryRow.scrollWidth;
            if (!baseWidth) {
                return;
            }

            var viewportWidth = section.clientWidth;
            var totalWidth = baseWidth;

            while (totalWidth < viewportWidth + baseWidth) {
                var clonedRow = primaryRow.cloneNode(true);
                clonedRow.setAttribute('aria-hidden', 'true');
                track.appendChild(clonedRow);
                totalWidth += baseWidth;
            }
        };

        /* --- Stop animation ----------------------------- */
        var stop = function () {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
                animationFrameId = null;
            }
        };

        /* --- RAF animation step ------------------------- */
        var step = function (timestamp) {
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !baseWidth) {
                track.style.transform = 'translate3d(0, 0, 0)';
                animationFrameId = null;
                return;
            }

            if (lastTimestamp === null) {
                lastTimestamp = timestamp;
            }

            var delta = (timestamp - lastTimestamp) / 1000;
            lastTimestamp = timestamp;

            offset += getSpeed() * delta;

            if (offset >= baseWidth) {
                offset = offset % baseWidth;
            }

            track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
            animationFrameId = requestAnimationFrame(step);
        };

        /* --- Rebuild and restart ------------------------ */
        var restart = function () {
            stop();
            lastTimestamp = null;
            offset = 0;
            baseWidth = 0;
            track.style.transform = 'translate3d(0, 0, 0)';
            buildTracks();

            if (baseWidth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                animationFrameId = requestAnimationFrame(step);
            }
        };

        /* --- Listen for image loads --------------------- */
        Array.from(section.querySelectorAll('img')).forEach(function (image) {
            if (!image.complete) {
                image.addEventListener('load', restart, { once: true });
                image.addEventListener('error', restart, { once: true });
            }
        });

        /* --- Listen for resize -------------------------- */
        if (typeof ResizeObserver !== 'undefined') {
            var resizeObserver = new ResizeObserver(restart);
            resizeObserver.observe(section);
        } else {
            window.addEventListener('resize', restart);
        }

        /* --- Kick off ----------------------------------- */
        restart();
    }

    /* --- Initialise all existing instances ------------ */
    sections.forEach(function (section) {
        initEndorsed(section);
    });

    /* --- Shopify section-load re-initialisation ------- */
    document.addEventListener('shopify:section:load', function (event) {
        var incomingSections = event.target.querySelectorAll('.collect-endorsed-section');

        if (!incomingSections.length) {
            return;
        }

        incomingSections.forEach(function (section) {
            initEndorsed(section);
        });
    });

});
